import Page from '@/components/Page'
import PostList from '@/components/Post/PostList'
import SearchBar from '@/components/Search/SearchBar'
import { Tab } from '@/components/Sidebar/config'
import { EXPLORE_POSTS_QUERY_OPTIONS } from '@/utils/fetchers/post'
import usePosts from '@/utils/hooks/usePosts'
import useTabClickListener from '@/utils/hooks/useTabClickListener'
import { prepareToRefetchListQuery } from '@/utils/list'
import queryClient from '@/utils/queryClient'
import { css } from '@emotion/react'
import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { useTitle } from 'react-use'

export const Route = createFileRoute('/explore')({
	component: ExplorePage,
	preload: false,
	loader: async () => {
		await queryClient.ensureInfiniteQueryData(EXPLORE_POSTS_QUERY_OPTIONS)
	},
})

export default function ExplorePage() {
	useTitle(`发现 - 即刻`)

	const { data, fetchNextPage, refetch, isFetching } = useSuspenseInfiniteQuery(
		EXPLORE_POSTS_QUERY_OPTIONS
	)
	const postIds = useMemo(() => data.pages.flatMap((page) => page.data), [data.pages])
	const posts = usePosts(postIds)

	useTabClickListener(
		Tab.EXPLORE_POST,
		useCallback(() => {
			prepareToRefetchListQuery(EXPLORE_POSTS_QUERY_OPTIONS.queryKey)
			refetch()
		}, [refetch])
	)

	return (
		<Page onReachPageBottom={fetchNextPage}>
			<div
				css={css`
					margin: 20px 0 0;
					padding-top: 12px;
					position: sticky;
					top: 0;
					z-index: 3;
				`}
			>
				<SearchBar />
			</div>
			<PostList data={posts} isFetching={isFetching} />
		</Page>
	)
}
